import { motion } from "framer-motion";
import KrishnaAvatar from "@/components/KrishnaAvatar";
import UserAvatar from "@/components/UserAvatar";
import PeacockSplash from "@/components/PeacockSplash";

export default function MessageBubble({ role, text, parsed, isGreeting }) {
  if (role === "user") {
    return (
      <motion.div
        initial={{ opacity: 0, y: 6, x: 20 }}
        animate={{ opacity: 1, y: 0, x: 0 }}
        transition={{ duration: 0.4, ease: [0.22, 0.9, 0.32, 1] }}
        className="flex items-start gap-3 justify-end w-full"
        data-testid="msg-user"
      >
        <div className="max-w-[85%] sm:max-w-[70%] order-1">
          <div
            className="rounded-3xl rounded-tr-sm text-neutral-900 text-[14.5px] leading-relaxed px-5 py-3.5 shadow-[0_10px_30px_-20px_rgba(197,160,89,0.6)]"
            style={{
              background: "linear-gradient(135deg, #FFF7E4 0%, #FFFBF1 60%, #FFFFFF 100%)",
              border: "1px solid rgba(197,160,89,0.35)",
            }}
          >
            {text}
          </div>
        </div>
        <UserAvatar size={36} className="mt-0.5 order-2" />
      </motion.div>
    );
  }

  const hasParagraphs = parsed && parsed.paragraphs && parsed.paragraphs.length > 0;

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.55, ease: [0.22, 0.9, 0.32, 1] }}
      className="flex items-start gap-3 w-full"
      data-testid="msg-ai"
    >
      <KrishnaAvatar size={40} className="mt-0.5" />
      <div className="relative w-full sm:max-w-[85%]">
        {!isGreeting && <PeacockSplash active={true} />}

        <div
          className="relative z-10 rounded-3xl rounded-tl-sm bg-white/85 backdrop-blur-md p-6 sm:p-7 kalki-shimmer-border"
          style={{
            border: "1px solid rgba(197,160,89,0.35)",
            boxShadow:
              "0 10px 40px -24px rgba(197,160,89,0.55), 0 1px 0 rgba(255,255,255,0.7) inset",
          }}
        >
          {isGreeting ? (
            <p className="text-[15.5px] sm:text-[16px] leading-relaxed text-neutral-800 whitespace-pre-line">
              {text}
            </p>
          ) : hasParagraphs ? (
            <div className="space-y-4 text-[14.5px] sm:text-[15px] leading-relaxed text-neutral-800">
              {parsed.paragraphs.map((p, idx) => {
                if (p.isAction) {
                  // Highlighted action card with subtle golden accent
                  const rest = p.text.replace(/^today\s*,\s*/i, "");
                  return (
                    <div
                      key={idx}
                      className="rounded-2xl border border-[#EFDDB2] bg-gradient-to-b from-[#FFFBF1] to-white px-4 py-3"
                    >
                      <div className="text-[10px] font-semibold tracking-[0.3em] uppercase gold-text mb-1">
                        Today with KALKI
                      </div>
                      <p className="text-[14.5px] leading-relaxed text-neutral-900 font-medium">
                        {rest}
                      </p>
                    </div>
                  );
                }
                const isOpening = idx === 0;
                const isClosing = idx === parsed.paragraphs.length - 1;
                return (
                  <p
                    key={idx}
                    className={
                      "leading-relaxed " +
                      (isOpening
                        ? "text-neutral-900 font-medium"
                        : isClosing
                        ? "text-neutral-700 italic"
                        : "text-neutral-700")
                    }
                  >
                    {p.text}
                  </p>
                );
              })}
            </div>
          ) : (
            <p className="text-[14.5px] sm:text-[15px] leading-relaxed text-neutral-800 whitespace-pre-line">
              {text}
            </p>
          )}
        </div>
      </div>
    </motion.div>
  );
}
